import { ADD_HOLIDAY, ADD_HOLIDAY_FAILED, ADD_HOLIDAY_SUCCESS, HOLIDAY, HOLIDAY_FAILED, HOLIDAY_SUCCESS, UPDATE_HOLIDAY, UPDATE_HOLIDAY_FAILED, UPDATE_HOLIDAY_SUCCESS } from "./actionTypes"

let initialState = {
    holiday: [],
    addHoliday: "",
    updateHoliday: "",
    loading: false,
    success: false,
    error: ''
}

export const holidayReducer = (state = initialState, action) => {
    switch (action.type) {

        case HOLIDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case HOLIDAY_SUCCESS: return {
            ...state,
            holiday: action.payload,
            loading: false,
            success: true
        }
        case HOLIDAY_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_HOLIDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_HOLIDAY_SUCCESS: return {
            ...state,
            addHoliday: action.payload,
            holiday: [...state.holiday, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_HOLIDAY_FAILED: return {
            ...state,
            addHoliday: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_HOLIDAY: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_HOLIDAY_SUCCESS: return {
            ...state,
            updateHoliday: action.payload,
            holiday: state.holiday.map((item) => item.id === action.payload._id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_HOLIDAY_FAILED: return {
            ...state,
            updateHoliday: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}